
import {SET_NOTIFICATION} from './constants'
export default {
    async setNotification({ commit },data) {
        commit(SET_NOTIFICATION,data)
    }
}
